import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { PublicFilesService } from 'app/services/public-files.service';

@Component({
  selector: 'app-file-visor',
  templateUrl: './file-visor.component.html',
  styleUrls: ['./file-visor.component.scss']
})
export class FileVisorComponent implements OnInit {

  type: string;
  url;
  base64; 
  //application/vnd.openxmlformats-officedocument.wordprocessingml.document
  //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FileVisorComponent>,
    private sanitizer: DomSanitizer,
    private fileService: PublicFilesService,
    private fuseProgressbar: FuseProgressBarService,
  ) { 

    this.type = data.type;
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
    switch(this.type){
      case 'application/pdf':
        this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,'+ data.base64);
        break;
      case 'image/png':
        this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,'+ data.base64);
        break;
      // default:
        // this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,'+ data.base64);
    }
    console.log(this.base64);
  }

  ngOnInit(): void {
  }

  downloadFile(){
    this.fuseProgressbar.show();
    this.fileService.downloadFileTemplate(this.data.fileId)
    .subscribe(() =>this.fuseProgressbar.hide());
  }

}
